import React from 'react';
import { motion } from 'framer-motion';
import { useApp } from '@/context/AppContext';
import { PageHeader, Card } from '@/components/common';
import { toast } from 'sonner';
import { MessageSquare, Calendar } from 'lucide-react';

const Team = () => {
  const { t, tx, data, setAdvisorOpen } = useApp();

  return (
    <div>
      <PageHeader title={t('team.title')} subtitle={t('team.subtitle')} />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {data.team.map((m, i) => (
          <motion.div key={m.id} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.08 }}>
            <Card className="p-6 flex flex-col items-center text-center" hover data-testid={`team-${m.id}`}>
              <div className="relative mb-4">
                <div className="w-20 h-20 rounded-full overflow-hidden bg-zinc-100 ring-4 ring-zinc-50">
                  {m.avatar
                    ? <img src={m.avatar} alt={m.name} className="w-full h-full object-cover" />
                    : <div className="w-full h-full flex items-center justify-center text-2xl font-heading font-bold text-zinc-400">{m.name[0]}</div>}
                </div>
                {m.online && <span className="absolute bottom-1 right-1 w-4 h-4 rounded-full bg-emerald-500 border-2 border-white" />}
              </div>
              <h3 className="font-heading font-semibold text-zinc-900">{m.name}</h3>
              <p className="text-sm text-zinc-500 mb-4">{tx(m.role)}</p>
              <div className="flex gap-2 w-full">
                <button onClick={() => setAdvisorOpen(true)} data-testid={`team-contact-${m.id}`} className="flex-1 h-9 rounded-lg bg-zinc-900 hover:bg-zinc-800 text-white text-xs font-semibold flex items-center justify-center gap-1.5 transition-colors">
                  <MessageSquare className="w-3.5 h-3.5" /> {t('team.contact')}
                </button>
                <button onClick={() => toast.success(tx({ es: 'Solicitud de reunión enviada', en: 'Meeting request sent' }))} data-testid={`team-book-${m.id}`} className="flex-1 h-9 rounded-lg border border-zinc-200 text-zinc-600 hover:bg-zinc-50 text-xs font-semibold flex items-center justify-center gap-1.5 transition-colors">
                  <Calendar className="w-3.5 h-3.5" /> {t('team.book')}
                </button>
              </div>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Team;
